import { memo } from 'react'
import { PaperAirplaneIcon, ClockIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import { getTimeRemaining } from '../../utils/timeFormatters'

/**
 * MessageInput - Input area for sending channel messages with rate limit display
 */
const MessageInput = memo(function MessageInput({
  newMessage,
  canPost,
  rateLimitInfo,
  sending,
  onMessageChange,
  onSubmit
}) {
  const { t } = useTranslation()

  const charCount = newMessage.trim().length
  const isValid = charCount >= 10
  const showCharWarning = charCount > 0 && charCount < 10

  return (
    <div className="flex-shrink-0 p-3 border-t border-gray-200">
      {rateLimitInfo && !canPost && (
        <div className="mb-2 p-2 bg-yellow-50/80 backdrop-blur-sm border border-yellow-200/50 rounded-lg text-xs text-yellow-800 flex items-center gap-1 shadow-sm">
          <ClockIcon className="w-4 h-4" />
          <span>{t('channels.message.rateLimit', { time: getTimeRemaining(rateLimitInfo.nextPostAt, t) })}</span>
        </div>
      )}
      <form onSubmit={onSubmit} className="space-y-2">
        <div className="flex gap-2">
          <input
            id="channel-message-input"
            name="message"
            type="text"
            value={newMessage}
            onChange={(e) => onMessageChange(e.target.value)}
            placeholder={t('channels.message.placeholder')}
            disabled={!canPost || sending}
            autoComplete="off"
            className="flex-1 px-3 py-2 text-sm bg-white/90 backdrop-blur-sm border border-gray-200/50 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-gray-100/80 shadow-sm hover:bg-white transition-colors"
          />
          <button
            type="submit"
            disabled={!isValid || !canPost || sending}
            className="px-3 py-2 bg-primary text-white rounded-lg hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1 shadow-sm hover:shadow-md transition-all duration-200"
          >
            <PaperAirplaneIcon className="w-4 h-4" />
          </button>
        </div>
        {showCharWarning && (
          <div className="text-xs text-gray-500">
            {t('channels.message.charactersRemaining', { count: 10 - charCount })}
          </div>
        )}
      </form>
    </div>
  )
})

export default MessageInput
